/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: program_role.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type { ListProgramRolesRequest, ListProgramRolesResponse } from '../types/program_role';

export const createProgramRoleService = (transport: Transport) => ({
  async listProgramRoles(
    request: ListProgramRolesRequest,
    options: RequestOptions = {},
  ): Promise<ListProgramRolesResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.ProgramRoleService.ListProgramRoles, {
      organization_id,
      program_id,
    });
    return transport.get<ListProgramRolesResponse>(url, { params, ...options });
  },
});

export type ProgramRoleService = ReturnType<typeof createProgramRoleService>;
